// projectsData.jsx

import mlProject0Thumb from "../assets/project_thumbnails/ml_project_0_thumbnail.jpg";
import mlProject1Thumb from "../assets/project_thumbnails/ml_project_1_thumbnail.webp";
import mlProject2Thumb from "../assets/project_thumbnails/ml_project_2_thumbnail.webp";
import otherProject1Thumb from "../assets/project_thumbnails/data_project_1_thumbnail.webp";
import chartsightThumb from "../assets/project_thumbnails/chartsight_thumbnail.webp";
import macrolensThumb from "../assets/project_thumbnails/macrolens_thumbnail.webp";
import probeThumb from "../assets/project_thumbnails/probe_thumbnail.webp";

export const projects = [
  // Ordered strongest / most recent first — the first row is what most visitors see.
  {
    id: "probe",
    category: "ml",
    title: "Probe",
    tagline:
      "AI mock interviewer: a multi-agent LangGraph pipeline that targets the gaps between your resume and the job, follows up on weak answers, and reveals scores only at the end.",
    thumbnail: probeThumb,
    technologies: [
      { name: "LangGraph", icon: "fas fa-project-diagram" },
      { name: "FastAPI", icon: "fab fa-python" },
      { name: "Google Gemini", icon: "fab fa-google" },
      { name: "React", icon: "fab fa-react" },
      { name: "Supabase", icon: "fas fa-database" },
    ],
    liveLink: "https://probe-interview-ai.vercel.app/",
    repoLink: "https://github.com/Sailesh75/Probe",
  },
  {
    id: "chartsight",
    category: "ml",
    title: "ChartSight",
    tagline:
      "Evidence-linked HCC coding: an LLM pipeline that pulls ICD-10-CM codes from clinical notes with verbatim citations and flags risk-adjustment documentation gaps.",
    thumbnail: chartsightThumb,
    technologies: [
      { name: "Python", icon: "fab fa-python" },
      { name: "Amazon Bedrock", icon: "fab fa-aws" },
      { name: "LLMs", icon: "fas fa-robot" },
      { name: "Clinical NLP", icon: "fas fa-notes-medical" },
    ],
    liveLink: "https://5zsg4er4aoovrris3vtems7kae0aoeyr.lambda-url.us-east-1.on.aws/",
    repoLink: "https://github.com/Sailesh75/chartsight",
  },
  {
    id: "macro-lens",
    category: "other",
    title: "MacroLens",
    tagline:
      "AI-vision meal logging that identifies foods from a photo, matches them to USDA nutrition data, and learns your portion sizes over time.",
    thumbnail: macrolensThumb,
    technologies: [
      { name: "React", icon: "fab fa-react" },
      { name: "FastAPI", icon: "fab fa-python" },
      { name: "Google Gemini", icon: "fab fa-google" },
      { name: "Supabase", icon: "fas fa-database" },
    ],
    liveLink: "https://macro-lens-scan-ai.vercel.app/",
    repoLink: "https://github.com/Sailesh75/macro-lens",
  },
  {
    id: "ml-project-0",
    category: "ml",
    title: "Commit Message Generation using LLMs",
    tagline:
      "A novel Change Event Representation (CER) pipeline that uses LLMs to generate semantically-aware commit messages, outperforming diff-only baselines.",
    thumbnail: mlProject0Thumb,
    technologies: [
      { name: "Python", icon: "fab fa-python" },
      { name: "LLMs", icon: "fas fa-robot" },
      { name: "NLP", icon: "fas fa-language" },
      { name: "Prompt Engineering", icon: "fas fa-code-branch" },
    ],
    repoLink: "https://github.com/Sailesh75/Commit-Message-Generation",
  },
  {
    id: "other-project-1",
    category: "data",
    title: "Big Data Pipeline Architecture for Healthcare Analytics",
    tagline:
      "Scalable healthcare analytics architecture using Kafka, NiFi, Spark Streaming, and HDFS for batch and real-time ingestion.",
    thumbnail: otherProject1Thumb,
    technologies: [
      { name: "Apache Kafka", icon: "fas fa-stream" },
      { name: "Apache NiFi", icon: "fas fa-project-diagram" },
      { name: "Spark Streaming", icon: "fas fa-bolt" },
      { name: "HDFS", icon: "fas fa-database" },
    ],
    repoLink: "https://gitlab.com/cs65001/cs6500_sp2025_a05_g06",
  },
  {
    id: "ml-project-1",
    category: "ml",
    title: "Automatic HTML Code Generator",
    tagline:
      "AI-powered code generation that automatically creates HTML markup using LSTM.",
    thumbnail: mlProject1Thumb,
    technologies: [
      { name: "Python", icon: "fab fa-python" },
      { name: "Machine Learning", icon: "fas fa-brain" },
      { name: "NLP", icon: "fas fa-language" },
    ],
    repoLink: "https://github.com/Sailesh75/Automatic-HTML-code-generator-",
  },
  {
    id: "ml-project-2",
    category: "ml",
    title: "Realistic Rendering System",
    tagline:
      "Colorize grayscale and black-and-white images using Generative Adversarial Networks (GANs).",
    thumbnail: mlProject2Thumb,
    technologies: [
      { name: "Python", icon: "fab fa-python" },
      { name: "Machine Learning", icon: "fas fa-brain" },
      { name: "Computer Vision", icon: "fas fa-eye" },
    ],
    repoLink: "https://github.com/Sailesh75/Realistic-rendering-system",
    liveLink:
      "https://www.researchgate.net/publication/356811882_REALISTIC_RENDERING_SYSTEM_USING_GAN",
  },
];
